import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from 'components/UI/BaseDropdown/dropdown-base'
import { cn } from 'components/UI/cn'
import {
  ArrowDownNarrowWide,
  ArrowUpDown,
  ArrowUpNarrowWide,
  Triangle,
} from 'lucide-react'

type SortOption = 'overrides' | 'asc' | 'desc' | null

interface CuisineSortDropdownProps {
  selected: SortOption
  onSelect: (value: SortOption) => void
}

export function CuisineSortDropdown({
  selected,
  onSelect,
}: CuisineSortDropdownProps) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        className={cn(
          'flex items-center gap-2 px-3 py-2 text-sm text-gray-700 rounded-3xl',
          'hover:bg-surface-active',
          'border-transparent',
          'data-[state=open]:bg-surface-active'
        )}
      >
        <ArrowUpDown className="h-4 w-4" />
        <span>Sort</span>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="w-48 p-1">
        <DropdownMenuItem
          onClick={() => onSelect('overrides')}
          className={cn(
            'flex items-center gap-2 px-2 py-1.5 text-sm rounded-md',
            'hover:bg-surface-active',
            selected === 'overrides' && 'bg-surface-active'
          )}
        >
          <Triangle className="h-4 w-4" />
          <span>Overrides</span>
        </DropdownMenuItem>
        <DropdownMenuItem
          onClick={() => onSelect('asc')}
          className={cn(
            'flex items-center gap-2 px-2 py-1.5 text-sm rounded-md',
            'hover:bg-surface-active',
            selected === 'asc' && 'bg-surface-active'
          )}
        >
          <ArrowUpNarrowWide className="h-4 w-4" />
          <span>Sort ascending</span>
        </DropdownMenuItem>
        <DropdownMenuItem
          onClick={() => onSelect('desc')}
          className={cn(
            'flex items-center gap-2 px-2 py-1.5 text-sm rounded-md',
            'hover:bg-surface-active',
            selected === 'desc' && 'bg-surface-active'
          )}
        >
          <ArrowDownNarrowWide className="h-4 w-4" />
          <span>Sort descending</span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
